/**
 * @name PendingJobChange
 * @description Componente de autorización de cambio de puesto
 * @author Alexis Becerra
 */

import i18n from 'i18next';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import React, { Component } from 'react';
import { Icons, MUI, Typography } from 'styles';
import { Environment } from '@config';

// Service
import { EmployeeService, ResponseHandlerService, JobChangeService, NotificationsService } from '@services';

// Components
import { DataGrid, EmployeeDetail } from '@components';
import Validate from './components/validate';
import CommentDialog from './components/comment.dialog';


class PendingJobChange extends Component {
  constructor(props) {
    super(props);

    this.dataGridRef = React.createRef();
    this.enterpriseParams = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empresa;
    this.userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
    this.state = {
      employeeId: props.queryParams.get('idEmpleado') ? props.queryParams.get('idEmpleado') : this.userInfo.IdEmpleado,
      isThirdLevel: this.userInfo.NivelJerarquia === 3,
      isSupervisor: this.userInfo.NivelJerarquia >= 2,
      gridConfig: {
        rows: [],
        columns: [
          { id: 'Nombre', label: i18n.t('GenericMessages.name'), visible: true, filter: null },
          { id: 'PuestoActual', label: i18n.t('Request.actualJob'), visible: true, filter: null },
          { id: 'Puesto', label: i18n.t('Request.requiredJob'), visible: true, filter: null },
          { id: 'Autorizado', label: i18n.t('GenericMessages.status'), visible: true, filter: 'YesNoFilter' },
        ],
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canSelect: false,
      },
      showCommentDialog: {
        action: '',
        open: false
      },
      employeeFilter: {
        id: this.userInfo.IdEmpleado,
        name: `${this.userInfo.Nombres} ${this.userInfo.Apellidos}`,
        status: '',
        photo: '',
        job: ''
      },
      structure: [],
      selectedEmployeeFromFilter: '',
      myRequest: true,
      flagResults: false
    };
  }

  componentDidMount() {

    const {
      isSupervisor,
      isThirdLevel
    } = this.state;


    this.getPendingRequest();

    if (isSupervisor || isThirdLevel) {
      this.getStructure();
    }
  }

  /**
 * Filtra las responsabilidades de un usuario
 * @param {object} employee
 */
  filterShedule = (employee) => {

    if (employee) {
      this.setState({ myRequest: false });
    } else {
      this.setState({ myRequest: true });
    }

    this.setState({
      employeeFilter: {
        id: employee ? employee.IdEmpleado : this.userInfo.IdEmpleado,
        name: employee ? employee.Nombre : `${this.userInfo.Nombres} ${this.userInfo.Apellidos}`,
        photo: employee ? employee.Foto : '',
        job: employee ? employee.Puesto : ''
      },
      isSupervisor: employee ? employee.IdReporta === this.userInfo.IdEmpleado : this.userInfo.NivelJerarquia >= 2,
      isThirdLevel: employee ? employee.IdReporta !== this.userInfo.IdEmpleado : this.userInfo.NivelJerarquia === 3,
      employeeId: employee ? employee.IdEmpleado : this.userInfo.IdEmpleado,
    });

    let employeeId = employee ? employee.IdEmpleado : this.userInfo.IdEmpleado;
    this.getPendingRequest(employeeId);
  }

  /**
  * Consulta la estructura del supervisor o tercer nivel
  */
  getStructure = () => {
    const configFilter = {
      tipoEstructura: true,
      estructuraDirecta: true
    };

    EmployeeService.getStructure({ page: 0, size: 0, filter: configFilter })
      .then((response) => {
        this.setState({ structure: response });
      })
      .catch(() => { });
  }

  /**
  * Consulta las solicitudes pendientes de un empleado
  * @param {number} employeeId
  */
  getPendingRequest = (employee) => {
    if (employee) {

      JobChangeService.getDataPending(employee)
        .then((response) => {
          this.setState({
            flagResults: true
          });
          const { gridConfig } = this.state;
          gridConfig.rows = response;
          this.setState((prevState) => ({
            gridConfig: { ...prevState.gridConfig, gridConfig },
          }));
        })
        .catch((error) => {
          ResponseHandlerService.error(error);
          const { gridConfig } = this.state;
          gridConfig.rows = [];
          this.setState((prevState) => ({
            gridConfig: { ...prevState.gridConfig, gridConfig },
          }));
        });
    } else {
      let IdEmpleado = this.state.employeeId;

      JobChangeService.getDataPending(IdEmpleado)
        .then((response) => {
          this.setState({
            flagResults: true
          });
          const { gridConfig } = this.state;
          gridConfig.rows = response;
          this.setState((prevState) => ({
            gridConfig: { ...prevState.gridConfig, gridConfig },
          }));
        })
        .catch((error) => {
          ResponseHandlerService.error(error);
          const { gridConfig } = this.state;
          gridConfig.rows = [];
          this.setState((prevState) => ({
            gridConfig: { ...prevState.gridConfig, gridConfig },
          }));
        });
    }
  }

  returnConfirmation = ({ comment }, resetForm) => {

    let request = {
      IdEmpleado: this.state.employeeFilter.id,
      IdPuesto: this.state.gridConfig.rows[0].IdPuesto,
      Comentario: comment,
    };

    let notificationToSend = {
      IdTipoNotificacion: 134,
      IdEmpleado: this.state.employeeFilter.id,
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      Parametros: JSON.stringify({ Tab: 8 })
    };

    let tipo = true;

    JobChangeService.put(tipo, request)
      .then((response) => {
        NotificationsService.post(notificationToSend)
          .then(() => {
            this.closeDialog('comment');
            this.getPendingRequest();
            resetForm();
            ResponseHandlerService.success(response);
            window.location.reload();
          })
          .catch((error) => {
            ResponseHandlerService.error(error);
          });
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  onApprove = () => {
    this.setState({ showCommentDialog: { action: 'approve', open: true } });
  }

  onReject = () => {
    this.setState({ showCommentDialog: { action: 'reject', open: true } });
  }

  rejectConfirmation = ({ comment }, resetForm) => {
    let request = {
      IdEmpleado: this.state.employeeFilter.id,
      IdPuesto: this.state.gridConfig.rows[0].IdPuesto,
      Comentario: comment,
    };

    let notificationToSend = {
      IdTipoNotificacion: 133,
      IdEmpleado: this.state.employeeFilter.id,
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      Parametros: JSON.stringify({ Tab: 8 })
    };

    let tipo = false;

    JobChangeService.put(tipo, request)
      .then((response) => {
        NotificationsService.post(notificationToSend)
          .then(() => {
            this.closeDialog('comment');
            resetForm();
            ResponseHandlerService.success(response);
            this.getPendingRequest();
            window.location.reload();
          })
          .catch((error) => {
            ResponseHandlerService.error(error);
          });
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  closeDialog = (dialog) => {
    if (dialog === 'comment') {
      this.setState({ showCommentDialog: { action: '', open: false } });
    }
  }

  render() {
    const {
      employeeFilter,
      selectedEmployeeFromFilter,
      gridConfig,
      isSupervisor,
      isThirdLevel,
      structure,
      myRequest,
      flagResults
    } = this.state;

    return (
      <>
        {/* Buscar colabordador (Supervisor/ThirdLevel) */}
        {(isSupervisor || isThirdLevel) && (
          <FilterWrapper>
            <MUI.Grid container alignItems="center">
              <MUI.Grid item md={4} sm={12}>
                <MUI.Box
                  padding="16px"
                  width="320px"
                >
                  <MUI.Autocomplete
                    label={<Trans>GenericMessages.employee</Trans>}
                    searchList={structure}
                    searchBy="Nombre"
                    value={selectedEmployeeFromFilter}
                    onChange={(newValue) => {
                      this.filterShedule(newValue);
                      this.setState({ selectedEmployeeFromFilter: newValue });
                    }}
                  />
                </MUI.Box>
              </MUI.Grid>
              <MUI.Grid item md={6} sm={12}>
                <BoxSeeingOf>
                  <BoxIcon>
                    <Icons.Info />
                  </BoxIcon>
                  {employeeFilter.id === this.userInfo.IdEmpleado ? (
                    <Typography.H6>{`${i18n.t('Request.lookingYouRequest')}.`}</Typography.H6>
                  ) : (
                    <>
                      <Typography.H6>{`${i18n.t('Request.lookingAtRequest')}:`}</Typography.H6>
                      <EmployeeCard>
                        <EmployeeDetail
                          avatar={employeeFilter.photo}
                          avatarSize="xs"
                          employeeName={employeeFilter.name}
                          employeeDetail={employeeFilter.job}
                        />
                      </EmployeeCard>
                    </>
                  )}
                </BoxSeeingOf>

              </MUI.Grid>

            </MUI.Grid>
          </FilterWrapper>
        )}

        <ContentWrapper>
          <MUI.Box padding="16px">
            <DataGrid ref={this.dataGridRef} columns={gridConfig.columns} rows={gridConfig.rows}
              canAdd={gridConfig.canAdd} canEdit={gridConfig.canEdit}
              canDelete={gridConfig.canDelete} canSelect={gridConfig.canSelect} canSelectMultiple={false}
              canSort={true} isPaginated={true}
            />
          </MUI.Box>

          <br />

          <Validate flagResults={flagResults} isSupervisor={isSupervisor} myShedule={myRequest} onApprove={this.onApprove}
            onReject={this.onReject}
          />

        </ContentWrapper>

        {/* Modal para regresar estatus o rechazar responsabilidades */}
        {this.state.showCommentDialog.open ? (
          <CommentDialog
            action={this.state.showCommentDialog.action}
            open={this.state.showCommentDialog.open}
            onClose={() => this.closeDialog('comment')}
            onRejectConfirmation={this.rejectConfirmation}
            onReturnConfirmation={this.returnConfirmation}
          />
        ) : null}

      </>
    );
  }
}

PendingJobChange.propTypes = {
  // Parámetros de la URL.
  queryParams: PropTypes.object,
  // Función para cambiar al Tab de pendientes.
  onChangeTab: PropTypes.func
};

// *************************************
// STYLED COMPONENTS
// *************************************
const FilterWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 8px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth2};
`;

const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth2};
`;

const BoxSeeingOf = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
`;

const EmployeeCard = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
`;

const BoxIcon = styled.div`
  display: flex;
  margin-right: 16px;

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;


export default PendingJobChange;